import React, { useState } from 'react';
import config from './config';
import { FaSync } from 'react-icons/fa';
import moment from 'moment';
import 'moment/locale/zh-tw';
import './EventUpload.css';

// Import components
import { ConstructionLogic, ResultsTable, WarningConditions } from '../components/EventUploadComponents';

// Set locale for moment
moment.locale('zh-tw');

// Settings object containing all configuration
const settings = {
    project_command: "hotel_image",
    priorityKeys: ['dangerous_environment', 'people_smoking', 'crowded', 'hallway_clutter', 'conflict_present'],
    keyTranslations: {
        number_of_people: '人數',
        clothing: '衣著',
        activity: '活動',
        position: '位置',
        location: '位置描述',
        ground: '地面',
        lighting: '光線',
        equipment_quantity: '設備數量',
        equipment_type: '設備類型',
        dangerous_environment: '危險環境',
        people_smoking: '有人吸煙',
        description: '說明',
        name: "酒店名稱",
        timestamp: "時間",
        image_url: '相片',
        thumbnail_url: '縮圖',
        crowded: '擁擠',
        hallway_clutter: '走廊雜亂',
        conflict_present: '衝突發生',
        warning: '警告'
    },
    site_type: "飯店",
    project_post_api: config.aiconstruction,
    media_upload_url: config.media2_upload,
    warningItems: [
        { key: 'dangerous_environment', label: '危險環境' },
        { key: 'people_smoking', label: '有人吸煙' },
        { key: 'crowded', label: '擁擠' },
        { key: 'hallway_clutter', label: '走廊雜亂' },
        { key: 'conflict_present', label: '衝突發生' }
    ],
    excludeKeys: ['id', 'time', 'thumbnail_url', 'image_url', 'anyone_not_wearing_helmets']
};

function Hotel() {
    const [showResults, setShowResults] = useState(false);

    const handleResultsDisplay = (hasResults) => {
        setShowResults(hasResults);
    };

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <>
            {showResults && (
                <div className="container d-flex justify-content-end mt-2">
                    <button
                        className="btn btn-secondary d-flex align-items-center gap-2"
                        onClick={handleReload}
                    >
                        <FaSync /> 重新偵測
                    </button>
                </div>
            )}
            {!showResults && (
                <div className="container text-center mt-0 mb-0">
                    <WarningConditions siteType={settings.site_type} warningItems={settings.warningItems} />
                </div>
            )}
            <ConstructionLogic
                keyTranslations={settings.keyTranslations}
                PROJECT_POST_API={settings.project_post_api}
                SITE_TYPE={settings.site_type}
                mediaUploadUrl={settings.media_upload_url}
                ResultsTableComponent={ResultsTable}
                configData={{
                    priorityKeys: settings.priorityKeys,
                    projectCommand: settings.project_command,
                    excludeKeys: settings.excludeKeys
                }}
                onResultsDisplay={handleResultsDisplay}
            />
        </>
    );
}

export default Hotel;
